import type { App } from 'vue';
import { createPinia } from "pinia";
import { pluginTasksStore } from "@/store/tasksStore";
import { pluginProjectsStore } from "@/store/projectsStore";
import {pluginDiaryStore} from "@/store/diaryStore";
import configStore from "@nextories/vue-core-components/src/utils/helpers/configStore";

// Create and export Pinia
export const pinia = createPinia();

export default {
  pluginStore: {
    tasks: pluginTasksStore,
    projects: pluginProjectsStore,
    diary: pluginDiaryStore,
  },
  install(app: App) {
    // Set state and actions in store pinia
    // diary
    // tasks
    // projects
    pinia.use(({ store }) => {
      if (store) {
        const plugin = this.pluginStore[store.$id];
        if (plugin) {
          configStore.updateStoreStateAndActions(
            store,
            plugin,
          );
        }
      }
    });
    app.use(pinia);
  },
};
